@if (template) {
  <div class="template-form">
    <div class="template-form-header">
      <h3>{{ formType === 'new' ? 'New template' : 'Edit template' }}</h3>
      <mat-icon class="close-icon" (click)="closeForm()">close</mat-icon>
    </div>
    <div class="template-form-body">
      @if (showActionConfirmOverlay) {
        <div class="on-save-overlay">
          <p>{{ overlayText }}</p>
        </div>
      }
      <div class="inputs">
        <div class="basicInput basicInput--width25 basicInput--marginRightMd">
          <span class="basicInput__label">Template name</span>
          <input class="basicInput__input" id="template-name" type="text" [(ngModel)]="template.title" />
        </div>
        <div class="basicInput basicInput--width75 basicInput--marginRightMd">
          <span class="basicInput__label">Template subject</span>
          <input class="basicInput__input" id="template-subject" type="text" [(ngModel)]="template.subject" />
        </div>
      </div>
      <div class="inputs" style="margin-top: 10px">
        <div class="basicInput basicInput--width25 basicInput--marginRightMd">
          <span class="basicInput__label">Template description</span>
          <input class="basicInput__input" id="template-description" type="text" [(ngModel)]="template.description" />
        </div>
        <div class="basicInput basicInput--width75 basicInput--marginRightMd">
          <span class="basicInput__label">Template preheader</span>
          <input class="basicInput__input" id="template-preheader" type="text" [(ngModel)]="template.preheader" />
        </div>
      </div>
      <div class="inputs" style="margin-top: 10px">
        <div class="basicInput basicInput--width25 basicInput--marginRightMd">
          <span class="basicInput__label">Language</span>
          <select
            class="basicInput__input"
            id="template-language"
            list="languages"
            name="languages"
            [disabled]="formType === 'edit'"
            [(ngModel)]="template.language"
          >
            @for (language of languageList; track language) {
              <option [value]="language">
                {{ language | language }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="form-editor">
        <pre style="height: 100%; display: flex" class="ngx-pre">
          @if (solicitationService.activeTemplate) {
            <textarea class="form-editor-textarea" id="editor-2" [(ngModel)]="template.content"></textarea>
          }
        </pre>
      </div>
    </div>
    <div class="template-form-actions">
      @if (formType === 'edit') {
        <button class="button button--danger" (click)="deleteTemplate()">Delete template</button>
      }
      <button class="button button--secondary" (click)="closeForm()">Cancel</button>
      @if (formType === 'edit') {
        <button class="button button--secondary" (click)="updateTemplate()">Update and apply</button>
      }
      @if (formType === 'new') {
        <button class="button button--secondary" (click)="saveTemplate()">Save and apply</button>
      }
    </div>
  </div>
}
